import { ReactComponent as Lupa } from '../../assets/icons/Lupa.svg';

import classes from './Search.module.scss';

const Search = ({ className, placeholder, onValueChange, onBlur, reference }) => {
  const changeHandler = event => {
    const {
      target: { value }
    } = event;
    onValueChange(value);
  };

  const containerClasses = ['input-search'];
  if (className) {
    containerClasses.push(className);
  }

  const inputClasses = ['input-search', 'medium-16', classes.input];

  return (
    <div className={classes.container}>
      <Lupa className={classes['input-icon']} />
      <input
        className={inputClasses.join(' ')}
        name='inputSearch'
        onChange={changeHandler}
        placeholder={placeholder}
        {...(!!onBlur && !!reference && { onBlur, ref: reference })}
      />
    </div>
  );
};

export default Search;

/* 
import Button from '../Buttons/Button/Button';
const search = () => {
    valueSetter(text);
  };
<Button name='buttonSearch' className={classes.button} onClick={search}>
        Buscar
      </Button> */
